module.exports = __webpack_public_path__ + "img/org-id.9ea29d60.png";